import { Component } from '@angular/core';

import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'summary',
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.css',
  standalone: false,
})
export class SummaryComponent {
  public isUploading = false;
  public readonly timeSheet = this.datahub.timesheet;
  public readonly contract = this.datahub.contract;

  constructor(private readonly datahub: DatahubService) {}

  get filteredEmployees() {
    return this.timeSheet.currentEmployeeCrew.filter((emp) => emp.workDateTotal > 0);
  }
  get filteredEquipment() {
    return this.timeSheet.currentEquipmentCrew.filter((eq) => eq.workDateTotal > 0);
  }

  public upload(): void {
    this.isUploading = true;
    this.timeSheet.upload$().subscribe({
      next: () => {
        this.isUploading = false;
      },
      error: () => {
        this.isUploading = false;
      },
      complete: () => {
        this.isUploading = false;
      },
    });
  }
}
